/**
 * I18N-RECETAS.JS — Traducciones de las CLAVES que declaran las recetas de rueda.
 *
 * Apartado SEPARADO de i18n-base.js (colores, UI general). Acá vive lo que la
 * receta nombra: ids/grupos de apuestas (directo, duo, linea, cuadra, color,
 * tercios, bloques, espejos...).
 *
 * REGLA DE ORO (docs/MODELO_RECETA_AGNOSTICA.md): la receta declara sus claves;
 * esas claves DEBEN existir acá. El código nunca traduce nombres ni mapea ids —
 * solo pide la clave. Las claves de la receta y las de este archivo son LAS
 * MISMAS. Hacer una rueda nueva = su receta + sus claves nuevas acá.
 *
 * Dos secciones:
 *
 *   recetas.<idioma>.<grupo>       — i18n por GRUPO de apuesta. Templates
 *                                    dinámicos ({{thirdRanges}}, {{blockKeys}},
 *                                    {{primary}}/{{secondary}}, {{lowRange}},
 *                                    {{twinNumbers}}, etc.) los resuelve
 *                                    `tWithConfig` desde la receta del sorteo
 *                                    activo. Lo consume prize-table /
 *                                    tabla de premios.
 *
 *   lineas.<idioma>.<idLinea>      — i18n por ID DE LÍNEA. Lo que se ve dentro
 *                                    de cada botón del mat. Una entrada por id
 *                                    agnóstico declarado en `mat.botones[]`.
 *                                    Una receta nueva con `linea: 'mamiferoOso'`
 *                                    declara su clave acá y el factory la
 *                                    consume vía `t('lineas.mamiferoOso')` —
 *                                    cero ramas en el código.
 *
 * IDIOMAS: es, en, pt, ru. shared/ es ESM; el backend lo importa con require.
 */

export const I18N_RECETAS = {
    recetas: {
        es: {
            directo: 'NUMERO',
            duo: 'DUO (2 numeros)',
            linea: 'LINEA (3 numeros)',
            cuadra: 'CUADRA (4 numeros)',
            dobleLinea: 'DOBLE LINEA (6 numeros)',
            loto: 'LOTO',
            basket: 'BASKET',
            color: 'COLOR ({{primary}} / {{secondary}})',
            paridad: 'PARIDAD',
            mitad: 'MEDIA ({{lowRange}} / {{highRange}})',
            tercios: 'TERCIO ({{thirdRanges}})',
            columnas: 'COLUMNA ({{columnLabels}})',
            bloques: 'BLOQUE ({{blockKeys}})',
            espejos: 'ESPEJOS ({{mirrorPairs}})',
            gemelos: 'GEMELOS ({{twinNumbers}})',
            duo: 'DÚO',
            pais: 'PAIS',
            argentina: 'ARGENTINA',
            brasil: 'BRASIL',
            uruguay: 'URUGUAY',
            mexico: 'MEXICO',
            alemania: 'ALEMANIA',
            francia: 'FRANCIA',
            espana: 'ESPAÑA',
            inglaterra: 'INGLATERRA',
            italia: 'ITALIA',
            portugal: 'PORTUGAL',
            paisesBajos: 'PAISES BAJOS',
            belgica: 'BELGICA',
            croacia: 'CROACIA',
            estadosUnidos: 'ESTADOS UNIDOS',
            japon: 'JAPON',
            coreaDelSur: 'COREA DEL SUR',
            continente: 'CONTINENTE',
            sudamerica: 'SUDAMERICA',
            centroamerica: 'CENTROAMERICA',
            europa: 'EUROPA',
            asia: 'ASIA',
        },
        en: {
            directo: 'NUMBER',
            duo: 'DUO (2 numbers)',
            linea: 'LINE (3 numbers)',
            cuadra: 'CORNER (4 numbers)',
            dobleLinea: 'DOUBLE LINE (6 numbers)',
            loto: 'LOTO',
            basket: 'BASKET',
            color: 'COLOR ({{primary}} / {{secondary}})',
            paridad: 'PARITY',
            mitad: 'HALF ({{lowRange}} / {{highRange}})',
            tercios: 'THIRD ({{thirdRanges}})',
            columnas: 'COLUMN ({{columnLabels}})',
            bloques: 'BLOCK ({{blockKeys}})',
            espejos: 'MIRRORS ({{mirrorPairs}})',
            gemelos: 'TWINS ({{twinNumbers}})',
            duo: 'SPLIT',
            pais: 'COUNTRY',
            argentina: 'ARGENTINA',
            brasil: 'BRAZIL',
            uruguay: 'URUGUAY',
            mexico: 'MEXICO',
            alemania: 'GERMANY',
            francia: 'FRANCE',
            espana: 'SPAIN',
            inglaterra: 'ENGLAND',
            italia: 'ITALY',
            portugal: 'PORTUGAL',
            paisesBajos: 'NETHERLANDS',
            belgica: 'BELGIUM',
            croacia: 'CROATIA',
            estadosUnidos: 'UNITED STATES',
            japon: 'JAPAN',
            coreaDelSur: 'SOUTH KOREA',
            continente: 'CONTINENT',
            sudamerica: 'SOUTH AMERICA',
            centroamerica: 'CENTRAL AMERICA',
            europa: 'EUROPE',
            asia: 'ASIA',
        },
        pt: {
            directo: 'NÚMERO',
            duo: 'DUO (2 números)',
            linea: 'LINHA (3 números)',
            cuadra: 'QUADRA (4 números)',
            dobleLinea: 'DUPLA LINHA (6 números)',
            loto: 'LOTO',
            basket: 'BASKET',
            color: 'COR ({{primary}} / {{secondary}})',
            paridad: 'PARIDADE',
            mitad: 'METADE ({{lowRange}} / {{highRange}})',
            tercios: 'TERÇO ({{thirdRanges}})',
            columnas: 'COLUNA ({{columnLabels}})',
            bloques: 'BLOCO ({{blockKeys}})',
            espejos: 'ESPELHOS ({{mirrorPairs}})',
            gemelos: 'GÊMEOS ({{twinNumbers}})',
            duo: 'DUPLA',
            pais: 'PAÍS',
            argentina: 'ARGENTINA',
            brasil: 'BRASIL',
            uruguay: 'URUGUAI',
            mexico: 'MÉXICO',
            alemania: 'ALEMANHA',
            francia: 'FRANÇA',
            espana: 'ESPANHA',
            inglaterra: 'INGLATERRA',
            italia: 'ITÁLIA',
            portugal: 'PORTUGAL',
            paisesBajos: 'PAÍSES BAIXOS',
            belgica: 'BÉLGICA',
            croacia: 'CROÁCIA',
            estadosUnidos: 'ESTADOS UNIDOS',
            japon: 'JAPÃO',
            coreaDelSur: 'COREIA DO SUL',
            continente: 'CONTINENTE',
            sudamerica: 'AMÉRICA DO SUL',
            centroamerica: 'AMÉRICA CENTRAL',
            europa: 'EUROPA',
            asia: 'ÁSIA',
        },
        ru: {
            directo: 'НОМЕР',
            duo: 'ДУО (2 номера)',
            linea: 'ЛИНИЯ (3 номера)',
            cuadra: 'КВАДРАТ (4 номера)',
            dobleLinea: 'ДВОЙНАЯ ЛИНИЯ (6 номеров)',
            loto: 'LOTO',
            basket: 'BASKET',
            color: 'ЦВЕТ ({{primary}} / {{secondary}})',
            paridad: 'ЧЁТНОСТЬ',
            mitad: 'ПОЛОВИНА ({{lowRange}} / {{highRange}})',
            tercios: 'ТРЕТЬ ({{thirdRanges}})',
            columnas: 'КОЛОНКА ({{columnLabels}})',
            bloques: 'БЛОК ({{blockKeys}})',
            espejos: 'ЗЕРКАЛА ({{mirrorPairs}})',
            gemelos: 'БЛИЗНЕЦЫ ({{twinNumbers}})',
            duo: 'ПАРА',
            pais: 'СТРАНА',
            argentina: 'АРГЕНТИНА',
            brasil: 'БРАЗИЛИЯ',
            uruguay: 'УРУГВАЙ',
            mexico: 'МЕКСИКА',
            alemania: 'ГЕРМАНИЯ',
            francia: 'ФРАНЦИЯ',
            espana: 'ИСПАНИЯ',
            inglaterra: 'АНГЛИЯ',
            italia: 'ИТАЛИЯ',
            portugal: 'ПОРТУГАЛИЯ',
            paisesBajos: 'НИДЕРЛАНДЫ',
            belgica: 'БЕЛЬГИЯ',
            croacia: 'ХОРВАТИЯ',
            estadosUnidos: 'США',
            japon: 'ЯПОНИЯ',
            coreaDelSur: 'ЮЖНАЯ КОРЕЯ',
            continente: 'КОНТИНЕНТ',
            sudamerica: 'ЮЖНАЯ АМЕРИКА',
            centroamerica: 'ЦЕНТРАЛЬНАЯ АМЕРИКА',
            europa: 'ЕВРОПА',
            asia: 'АЗИЯ',
        },
    },
    // Etiqueta visible por id de línea — lo que se ve DENTRO de cada botón del
    // mat. Una entrada por id agnóstico que aparece en `receta.mat.botones[]`.
    // El factory hace `t('lineas.${boton.linea}')` y muestra el resultado.
    // Cero ramas en el código.
    lineas: {
        es: {
            cero: '0',
            loto: 'LOTO',
            rojos: 'ROJO',
            negros: 'NEGRO',
            pares: 'PAR',
            impares: 'IMPAR',
            bajos: '{{lowRange}}',
            altos: '{{highRange}}',
            docena1: 'TERCIO 1',
            docena2: 'TERCIO 2',
            docena3: 'TERCIO 3',
            columna1: 'COL 1',
            columna2: 'COL 2',
            columna3: 'COL 3',
            bloqueA: 'A',
            bloqueB: 'B',
            bloqueC: 'C',
            bloqueD: 'D',
            bloqueE: 'E',
            bloqueF: 'F',
            gemelos: 'GEMELOS',
            duo: 'DÚO',
            espejos: 'ESPEJOS',
            espejo_12_21: '12/21',
            espejo_13_31: '13/31',
            espejo_23_32: '23/32',
            basket: 'BASKET',
            lotoTrio: '0-37-38',
            sudamerica: 'SUDAMERICA',
            centroamerica: 'CENTROAMERICA',
            europa: 'EUROPA',
            asia: 'ASIA',
        },
        en: {
            cero: '0',
            loto: 'LOTO',
            rojos: 'RED',
            negros: 'BLACK',
            pares: 'EVEN',
            impares: 'ODD',
            bajos: '{{lowRange}}',
            altos: '{{highRange}}',
            docena1: 'DOZEN 1',
            docena2: 'DOZEN 2',
            docena3: 'DOZEN 3',
            columna1: 'COL 1',
            columna2: 'COL 2',
            columna3: 'COL 3',
            bloqueA: 'A',
            bloqueB: 'B',
            bloqueC: 'C',
            bloqueD: 'D',
            bloqueE: 'E',
            bloqueF: 'F',
            gemelos: 'TWINS',
            duo: 'SPLIT',
            espejos: 'MIRRORS',
            espejo_12_21: '12/21',
            espejo_13_31: '13/31',
            espejo_23_32: '23/32',
            basket: 'BASKET',
            lotoTrio: '0-37-38',
            sudamerica: 'S. AMERICA',
            centroamerica: 'C. AMERICA',
            europa: 'EUROPE',
            asia: 'ASIA',
        },
        pt: {
            cero: '0',
            loto: 'LOTO',
            rojos: 'VERMELHO',
            negros: 'PRETO',
            pares: 'PAR',
            impares: 'ÍMPAR',
            bajos: '{{lowRange}}',
            altos: '{{highRange}}',
            docena1: 'TERÇO 1',
            docena2: 'TERÇO 2',
            docena3: 'TERÇO 3',
            columna1: 'COL 1',
            columna2: 'COL 2',
            columna3: 'COL 3',
            bloqueA: 'A',
            bloqueB: 'B',
            bloqueC: 'C',
            bloqueD: 'D',
            bloqueE: 'E',
            bloqueF: 'F',
            gemelos: 'GÊMEOS',
            duo: 'DUPLA',
            espejos: 'ESPELHOS',
            espejo_12_21: '12/21',
            espejo_13_31: '13/31',
            espejo_23_32: '23/32',
            basket: 'BASKET',
            lotoTrio: '0-37-38',
            sudamerica: 'AM. SUL',
            centroamerica: 'AM. CENTRAL',
            europa: 'EUROPA',
            asia: 'ÁSIA',
        },
        ru: {
            cero: '0',
            loto: 'LOTO',
            rojos: 'КРАСНОЕ',
            negros: 'ЧЁРНОЕ',
            pares: 'ЧЁТ',
            impares: 'НЕЧЁТ',
            bajos: '{{lowRange}}',
            altos: '{{highRange}}',
            docena1: 'ТРЕТЬ 1',
            docena2: 'ТРЕТЬ 2',
            docena3: 'ТРЕТЬ 3',
            columna1: 'КОЛ 1',
            columna2: 'КОЛ 2',
            columna3: 'КОЛ 3',
            bloqueA: 'A',
            bloqueB: 'B',
            bloqueC: 'C',
            bloqueD: 'D',
            bloqueE: 'E',
            bloqueF: 'F',
            gemelos: 'БЛИЗНЕЦЫ',
            duo: 'ПАРА',
            espejos: 'ЗЕРКАЛА',
            espejo_12_21: '12/21',
            espejo_13_31: '13/31',
            espejo_23_32: '23/32',
            basket: 'BASKET',
            lotoTrio: '0-37-38',
            sudamerica: 'Ю. АМЕРИКА',
            centroamerica: 'Ц. АМЕРИКА',
            europa: 'ЕВРОПА',
            asia: 'АЗИЯ',
        },
    },

    // Etiqueta corta del grupo de una apuesta, para encabezar su valor en el desglose
    // del resultado (Bloque: C, Color: Negro). El factory hace `t('grupos.${grupo}')`.
    grupos: {
        es: {
            color: 'Color',
            paridad: 'Paridad',
            mitad: 'Mitad',
            tercios: 'Tercio',
            columnas: 'Columna',
            bloques: 'Bloque',
            docenas: 'Docena',
        },
        en: {
            color: 'Color',
            paridad: 'Parity',
            mitad: 'Half',
            tercios: 'Third',
            columnas: 'Column',
            bloques: 'Block',
            docenas: 'Dozen',
        },
        pt: {
            color: 'Cor',
            paridad: 'Paridade',
            mitad: 'Metade',
            tercios: 'Terço',
            columnas: 'Coluna',
            bloques: 'Bloco',
            docenas: 'Dúzia',
        },
        ru: {
            color: 'Цвет',
            paridad: 'Чётность',
            mitad: 'Половина',
            tercios: 'Треть',
            columnas: 'Колонка',
            bloques: 'Блок',
            docenas: 'Дюжина',
        },
    },
};

export default I18N_RECETAS;

if (typeof module !== 'undefined' && module.exports) {
    module.exports = { I18N_RECETAS };
}
